import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DialogToolbarComponent } from './dialog-toolbar.component';

@NgModule({
  declarations: [DialogToolbarComponent],
  exports: [DialogToolbarComponent],
  imports: [CommonModule],
})
export class DialogToolbarModule {}
export { DialogToolbarComponent } from './dialog-toolbar.component';
